import { catchError } from 'rxjs/operators';
import { Injectable, inject } from '@angular/core';
import {
  HttpEvent,
  HttpInterceptor,
  HttpHandler,
  HttpRequest,
  HttpErrorResponse,
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { SessionExpiredModalComponent } from '../../components/modals/session-expired-modal/session-expired-modal.component';
import { ModalService } from '@schenck/rotec-components';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  private readonly modalService = inject(ModalService);

  private modalIsOpened = false;

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        const { status } = error;
        // hanlde 'unauthorized' response
        if (status === 401 && !this.modalIsOpened) {
          this.modalIsOpened = true;
          this.modalService.open(SessionExpiredModalComponent);
        }

        return throwError(error);
      })
    );
  }
}
